import EventsService from "./events.service";

let inject = [
    '$scope',
    'eventsService',
    'SharedService'
];

class EventsController {
    constructor($scope,eventsService,SharedService) {
        this.$scope = $scope;
        this.eventsService=eventsService;
        this.SharedService=SharedService;
        this.months=["Ene","Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
        this.pageName = "PAG-42";


        this.SharedService.getCMSBanners(this.pageName).then(response => {
            this.cmsData = response;
            this.shCtrl.setTags(this.cmsData.seo);
        });


    }
    

    $onInit() {
      this.eventsService.getEvents().then(response=>{
        this.events=response.eventos;
      });

    }
    getMonth(month){
        return this.months[month-1];
    }


}

EventsController.$inject = inject;

export default EventsController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/events/events.controller.js
 **/